module.exports = __webpack_public_path__ + "static/media/education.1cd00bed.svg";